import { TypedArrayId, UntypedArrayId } from '@jurinfor/typing';

export function transpose(table) {
  TypedArrayId(TypedArrayId((x) => x))(table);
  const n = table.length;
  const m = table[0].length;
  if (m === 0) return [];
  const res = [];
  for (let j = 0; j < m; ++j) {
    res.push([]);
  }
  for (let i = 0; i < n; ++i) {
    if (table[i].length !== m) {
      console.error(table);
      throw new Error('A matrix must be rectangular');
    }
    for (let j = 0; j < m; ++j) {
      res[j][i] = table[i][j];
    }
  }
  return res;
}

export function uniq(arr) {
  return [...new Set(UntypedArrayId(arr))];
}

export function groups(table, columnId) {
  return uniq(UntypedArrayId(table).map((row) => row[columnId]));
}

